
import { mapGetters } from "vuex";
import Avatar from "~/components/ui/Avatar.vue";
import ProfileTags from "@/components/v2/profile-tags.vue";

export default {
  components: {
    Avatar,
    ProfileTags,
  },

  props: {
    review: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      dateFormatOptions: {
        year: "numeric",
        month: "long",
        day: "numeric",

        hour: "2-digit",
        minute: "2-digit",
      },
    };
  },

  computed: {
    ...mapGetters({
      discreetMode: "getDiscreetStatus",
    }),

    profile() {
      return this.review.profile;
    },

    name() {
      return this.profile.name;
    },

    age() {
      return this.profile.age;
    },

    city() {
      return this.profile.city;
    },

    slug() {
      return this.profile.slug;
    },

    photo() {
      return this.profile.mainPhoto;
    },

    authorPhoto() {
      return this.review?.user?.photo;
    },

    authorName() {
      return this.review?.user?.name;
    },

    subject() {
      return this.review.subject;
    },

    reviewText() {
      return this.review.text;
    },

    date() {
      return this.review.updated_at;
    },
  },
};
